<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
<div class="organisation_management_page">
    <app-header [headerTitle]="headerTitle"></app-header>

    <div class="managementPage">

        <div class="add_org_btn">
            <button class="serchBtn" mat-button style="height: 44px;" (click)="editOrganization()">
                <mat-icon
                    style="margin-right: 0.2rem;margin-bottom: 4px; width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                Add Organization
            </button>
        </div>

        <div class="organisations" *ngIf="organisationData?.length">
            <ng-container *ngFor="let organisation of organisationData">
                <div class="card">
                    <div class="image" (click)="openTabsPage(organisation.id)">
                        <img [src]="organisation.imageLogo" alt="Org Image">
                    </div>
                    <div class="name" *ngIf="organisation.name">{{organisation.name}}</div>
                    <div class="actionsArea">
                        <button class="name" (click)="editOrganization(organisation)">edit</button>
                        <button class="name" (click)="deleteOrganization(organisation.id)">delete</button>
                    </div>


                    <button class="name" (click)="accessProgram(organisation)">
                        Access Program
                    </button>

                </div>
            </ng-container>

        </div>

    </div>
</div>